export default "__VITE_ASSET__DItFmALk__"